var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFireMono(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M24.393 12.145a.185.185 0 00-.235-.064.211.211 0 00-.13.227c.016.179.026.361.027.542a2.898 2.898 0 01-.789 2.02 2.54 2.54 0 01-1.88.804c-.967-.013-1.77-.541-2.32-1.528-.456-.816-.256-1.869-.044-2.984.124-.652.252-1.327.252-1.969 0-4.999-3.21-7.883-5.122-9.157A.197.197 0 0014.04 0a.21.21 0 00-.118.04.205.205 0 00-.086.213c.731 4.066-1.45 6.512-3.759 9.1C7.698 12.024 5 15.049 5 20.504 5 26.843 9.925 32 15.979 32c4.984 0 9.378-3.639 10.686-8.85.892-3.552-.042-8.078-2.272-11.005zm-8.14 17.401c-1.516.072-2.958-.497-4.06-1.6a5.945 5.945 0 01-1.713-4.176c0-2.933 1.071-5.087 3.952-7.946a.191.191 0 01.138-.062.21.21 0 01.094.024.206.206 0 01.116.213c-.103 1.255-.101 2.297.005 3.097.272 2.043 1.7 3.415 3.554 3.415.908 0 1.774-.358 2.437-1.008a.21.21 0 01.196-.059c.044.01.102.038.133.116.274.695.415 1.433.417 2.192.009 3.058-2.355 5.657-5.27 5.794z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFireMono);
export default __webpack_public_path__ + "static/media/fire-mono.da8e3fb8.svg";
export { ForwardRef as ReactComponent };